// extracted by css-extract-rspack-plugin
export default {"caption":"Caption_caption__Li3ZV","text01":"Caption_text01__LQwA7","text03":"Caption_text03__1yECy","error":"Caption_error__Lllhn"};